export default __webpack_public_path__ + "static/media/logo-bank-permata.5f40d3e3.png";